import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { SmsLogRequestModel } from '../business-entities/smslog-request-model';

@Injectable({
    providedIn: 'root'
})

export class LogofSmsEmailSentDataService {
    constructor(private dataProvider: DataService) {
    }

    GetSMSLogList(smsLogRequestModel: SmsLogRequestModel): any {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetSMSLogList, smsLogRequestModel).toPromise();
    }
    GetCommunicationList(model: any): any {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetSMSLogList, model).toPromise();
    }
    GetCustomerCommunicationList(model: any): any {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetCustomerCommList, model).toPromise();
    }
    GetAppointmentCommunicationList(model: any): any {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetAppointmentCommList, model).toPromise();
    }
}